import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { izleyiciService } from '../api/dbService';
import PageLayout from '../components/PageLayout';
import LoadingSpinner from '../components/LoadingSpinner';

export default function Viewers() {
  const [tab, setTab] = useState('benim');
  const [izleyiciler, setIzleyiciler] = useState([]);
  const [izlenenler, setIzlenenler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [sevkiyatlar, setSevkiyatlar] = useState([]);
  const [selectedSev, setSelectedSev] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    Promise.all([
      izleyiciService.getIzleyiciler(),
      izleyiciService.getIzledigiSevkiyatlar()
    ]).then(([r1, r2]) => {
      setIzleyiciler(r1.data || []);
      setIzlenenler(r2.data || []);
    }).finally(() => setLoading(false));
  }, []);

  async function openModal() {
    const res = await izleyiciService.getSevkiyatlarim();
    setSevkiyatlar(res.data || []);
    setModal(true);
  }

  async function handleAdd() {
    if (!selectedSev || !email) return toast.error('Sevkiyat ve email zorunlu');
    try {
      await izleyiciService.addIzleyici({ sevkiyat_id: selectedSev, izleyici_email: email });
      toast.success('İzleyici eklendi');
      setModal(false);
      const r = await izleyiciService.getIzleyiciler();
      setIzleyiciler(r.data || []);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Eklenemedi');
    }
  }

  async function handleSil(id) {
    await izleyiciService.sil(id);
    setIzleyiciler(prev => prev.filter(i => i.id !== id));
    toast.success('Kaldırıldı');
  }

  if (loading) return <PageLayout><LoadingSpinner /></PageLayout>;

  return (
    <PageLayout>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 fw-semibold">İzleyici İşlemleri</h5>
        <button className="btn btn-brand btn-sm" onClick={openModal}>+ İzleyici Ekle</button>
      </div>

      <ul className="nav nav-tabs mb-3">
        <li className="nav-item"><button className={`nav-link ${tab === 'benim' ? 'active' : ''}`} onClick={() => setTab('benim')}>Benim İzleyicilerim</button></li>
        <li className="nav-item"><button className={`nav-link ${tab === 'izledigim' ? 'active' : ''}`} onClick={() => setTab('izledigim')}>İzlediğim Sevkiyatlar</button></li>
      </ul>

      {tab === 'benim' && (
        <div className="table-responsive">
          <table className="table table-sm table-hover align-middle">
            <thead className="table-light">
              <tr><th>İzleyici</th><th>Email</th><th>Sevkiyat</th><th>Durum</th><th></th></tr>
            </thead>
            <tbody>
              {izleyiciler.map(i => (
                <tr key={i.id}>
                  <td>{i.ad_soyad || i.username}</td>
                  <td><small>{i.email}</small></td>
                  <td>{i.sevkiyat_adi}</td>
                  <td><span className={`badge bg-${i.durum === 'aktif' ? 'success' : 'secondary'}`}>{i.durum}</span></td>
                  <td><button className="btn btn-outline-danger btn-sm" onClick={() => handleSil(i.id)}>Kaldır</button></td>
                </tr>
              ))}
              {izleyiciler.length === 0 && <tr><td colSpan={5} className="text-center text-muted py-3">İzleyici yok</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'izledigim' && (
        <div className="table-responsive">
          <table className="table table-sm table-hover align-middle">
            <thead className="table-light"><tr><th>Sevkiyat</th><th>Sahibi</th><th>Firma</th><th>Durum</th></tr></thead>
            <tbody>
              {izlenenler.map(i => (
                <tr key={i.id}>
                  <td>{i.sevkiyat_adi}</td>
                  <td>{i.sahip_adi}</td>
                  <td>{i.sahip_firma}</td>
                  <td><span className={`badge bg-${i.tamamlandi_mi ? 'secondary' : 'success'}`}>{i.tamamlandi_mi ? 'Tamamlandı' : 'Aktif'}</span></td>
                </tr>
              ))}
              {izlenenler.length === 0 && <tr><td colSpan={4} className="text-center text-muted py-3">Yok</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {modal && (
        <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 400 }}>
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title">İzleyici Ekle</h6>
                <button className="btn-close" onClick={() => setModal(false)} />
              </div>
              <div className="modal-body">
                <label className="form-label small fw-semibold">Sevkiyat Seç</label>
                <select className="form-select mb-3" value={selectedSev} onChange={e => setSelectedSev(e.target.value)}>
                  <option value="">-- Seçin --</option>
                  {sevkiyatlar.map(s => <option key={s.id} value={s.id}>{s.sevkiyat_adi}</option>)}
                </select>
                <label className="form-label small fw-semibold">İzleyici Email</label>
                <input type="email" className="form-control" placeholder="kullanici@email.com" value={email} onChange={e => setEmail(e.target.value)} />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={() => setModal(false)}>İptal</button>
                <button className="btn btn-brand btn-sm" onClick={handleAdd}>Ekle</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </PageLayout>
  );
}
